import { Tooltip, TooltipProps } from 'antd';
import './styles.less';
import InputDate, { InputDateProps } from '../InputDate';
import { Info } from 'react-feather';
import { useWindowSize } from '@/hooks';

type Props = {
  inputDateProps?: InputDateProps;
  tooltipProps?: TooltipProps;
  isViewInfo?: boolean;
};

export default function InputDateWithInfo({
  inputDateProps,
  tooltipProps,
  isViewInfo = false,
  ...props
}: Props) {
  const { isMobile } = useWindowSize();

  return (
    <div className="input-date-info">
      <InputDate {...inputDateProps} {...props} />

      {!!isViewInfo && (
        <div className="icon-info">
          <Tooltip trigger={isMobile ? 'click' : 'hover'} {...tooltipProps}>
            <Info size={20} cursor="pointer" />
          </Tooltip>
        </div>
      )}
    </div>
  );
}
